
import Cookie from 'js-cookie'

$(document).ready(function() {
    if($('#track_business_id').length > 0) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        var businessId = $('#track_business_id').val();

        if (!Cookie.get('tracked_' + businessId)) {
            Cookie.set('tracked_' + businessId, true, { expires: 7 });
            $.post('/business/' + businessId + '/pageview', {});
        }
    }
});
